(() => {
  const eventPrefix = 'lakeblankets:';
  const trackedSearches = new WeakMap();

  const clean = (value, maxLength = 100) =>
    String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, maxLength);

  const campaignProperties = () => {
    const search = new URLSearchParams(window.location.search);
    const properties = {};

    ['source', 'medium', 'campaign', 'content', 'term'].forEach((key) => {
      const value = clean(search.get(`utm_${key}`));
      if (value) properties[`utm_${key}`] = value;
    });

    return properties;
  };

  const publish = (eventName, properties = {}) => {
    const analytics = window.Shopify?.analytics;
    if (!analytics?.publish) return false;

    analytics.publish(`${eventPrefix}${eventName}`, {
      ga_event_name: eventName,
      page_path: window.location.pathname,
      ...campaignProperties(),
      ...properties,
    });

    return true;
  };

  const fieldValue = (form, name) => clean(form.elements.namedItem(name)?.value);

  const trackLakeSearch = (input, source) => {
    const searchTerm = clean(input?.value);
    if (searchTerm.length < 2 || trackedSearches.get(input) === searchTerm) return;

    trackedSearches.set(input, searchTerm);
    publish('lb_lake_search', {
      search_term: searchTerm,
      search_source: source,
    });
  };

  const initSearchTracking = () => {
    document.querySelectorAll('.lb-v1-lake-search, .lb-v2-finder form').forEach((form) => {
      form.addEventListener('submit', () => {
        trackLakeSearch(form.querySelector('input[type="search"]'), 'lake_search_form');
      });
    });

    document.querySelectorAll('[data-lb-lake-search], [data-lb-directory-search]').forEach((input) => {
      input.addEventListener('change', () => trackLakeSearch(input, 'lake_finder'));
    });
  };

  const initLakeClickTracking = () => {
    document.addEventListener('click', (event) => {
      const link = event.target.closest(
        '.lb-lake-result, .lb-v1-lake-card, .lb-v2-lake-card, .lb-v1-mega-lake-card, [data-lb-directory-card] a',
      );
      if (!link) return;

      const card = link.closest('[data-lb-directory-card], .lb-v1-lake-card, .lb-v2-lake-card, .lb-lake-result');
      const lakeName = clean(
        card?.dataset?.lakeName ||
          link.querySelector('strong, b')?.textContent ||
          link.textContent,
      );

      publish('lb_lake_result_click', {
        lake_name: lakeName,
        destination_path: new URL(link.href, window.location.origin).pathname,
      });
    });
  };

  const initRequestTracking = () => {
    document.querySelectorAll('#LakeBlanketsRequestLakeForm, [data-lb-request-lake-form]').forEach((form) => {
      form.addEventListener('submit', () => {
        publish('lb_request_lake_submit', {
          lake_name: fieldValue(form, 'contact[Lake name]'),
          state: fieldValue(form, 'contact[State or province]') || fieldValue(form, 'contact[State]'),
          product_line:
            fieldValue(form, 'contact[Blanket style interest]') ||
            fieldValue(form, 'contact[Interested product line]'),
          submission_status: 'attempted',
        });
      });
    });
  };

  const initNotifyTracking = () => {
    document.querySelectorAll('#product-notify form, #lake-notify form').forEach((form) => {
      form.addEventListener('submit', () => {
        publish('lb_notify_me_submit', {
          product_handle: clean(
            form.querySelector('input[name="contact[tags]"]')?.value
              ?.split(',')
              .find((tag) => tag && !tag.includes('notify')),
          ),
        });
      });
    });
  };

  const initProductSelectionTracking = () => {
    document.addEventListener('click', (event) => {
      const card = event.target.closest('.lb-commerce-card[data-design-style]');
      const action = event.target.closest('a, button');
      if (!card || !action) return;

      publish('lb_design_style_select', {
        style_family: clean(card.dataset.designStyle),
        product_name: clean(card.querySelector('h3')?.textContent),
        destination_path: action.href ? new URL(action.href, window.location.origin).pathname : '',
      });
    });
  };

  const trackLakePageView = (attempt = 0) => {
    const lakePage = document.querySelector('.section-lb-lake-collection, .lb-v1-lake-page');
    if (!lakePage) return;

    const published = publish('lb_lake_page_view', {
      lake_name: clean(lakePage.querySelector('h1')?.textContent || document.querySelector('h1')?.textContent),
      page_handle: clean(window.location.pathname.split('/').filter(Boolean).pop()),
    });

    if (!published && attempt < 10) {
      window.setTimeout(() => trackLakePageView(attempt + 1), 100);
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    initSearchTracking();
    initLakeClickTracking();
    initRequestTracking();
    initNotifyTracking();
    initProductSelectionTracking();
    trackLakePageView();
  });
})();
